import styled from 'styled-components';

const Wrapper = styled.div`
  height: 80px;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
